export const createdAtFormat = 'dd MMM yyyy';
export const createdAtFullTimeFormat = 'dd MMM yyyy HH:mm';
export const createdAtFullTimeWithSecondsFormat = 'dd MMM yyyy HH:mm:ss';
export const createdAtFormatWithoutYear = 'dd MMM';
export const requestFormDateFormat = 'D MMM YYYY';
export const timeOffUntilDateFormat = 'd MMM';
export const filterDateFormat = 'D MMM YYYY';
export const associatePageDateFormat = 'dd MMM yyyy';
export const timeOffReportDateFormat = 'dd.MM';
export const createDateFormat = 'yyyy-MM-dd';
export const dateFieldPlaceholder = 'MM/DD/YYYY';
export const questionnaireListItemDateFormat = 'd MMM yyyy';
export const riskRadarTableDateFormat = 'dd.MM.yy';
export const compensationDateFieldFormat = 'DD/MM/YYYY';
export const overtimeUndertimeDateLabelFormat = 'MMMM, yyyy';

// TODO: check is the same hireDateDateFormat and hireDateFormDateFormat
export const hireDateDateFormat = 'dd.MM.yyyy';
export const hireDateFormDateFormat = 'DD.MM.YYYY';
